var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    viewBox: "0 0 18 18",
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }, /*#__PURE__*/React.createElement("rect", {
    height: 15,
    rx: 2.301167,
    width: 15,
    x: 2.5,
    y: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.5 13.125v-3.816667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 13.125v-3.816667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 13.125v-3.816667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.666667 13.125h6.666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.66666667 9.30833333h6.66666663v-1.48583333l-3.3333333-1.36416667-3.33333333 1.36416667z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanBank);
export default __webpack_public_path__ + "static/media/loan-bank.2830dc9d22b96aeb6db9dabe3bbfbde3.svg";
export { ForwardRef as ReactComponent };